module.exports = __webpack_public_path__ + "static/img/輾一-黃志華.a358598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/輾一-黃志華.jpg
// module id = +ajT
// module chunks = 1